import { Component } from 'react';
import { Button } from '../ui/button';

export default class WorkerPortalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Worker portal render error:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5 py-8">
        <div className="w-full max-w-sm rounded-2xl border border-red-200 bg-white p-6 text-center shadow-lg">
          <p className="text-lg font-semibold text-slate-900">We couldn't open your workspace</p>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Your sign-in is saved. Please reload the workspace. If the problem continues, contact Osabea support.
          </p>
          <Button
            className="mt-4 w-full"
            onClick={() => window.location.reload()}
          >
            Reload workspace
          </Button>
          <button
            type="button"
            className="mt-3 text-sm font-medium text-slate-600 underline underline-offset-2"
            onClick={() => {
              localStorage.removeItem('workerToken');
              localStorage.removeItem('workerEmployee');
              localStorage.removeItem('workerWorkspaceSlug');
              window.location.href = '/worker/login';
            }}
          >
            Return to sign in
          </button>
        </div>
      </div>
    );
  }
}
